import React from 'react';
import css from './MessageStatus.css';

export default ({ messageIsViewedByOtherParty }) => (
    <p className={css.messageStatus}>
        <span>{messageIsViewedByOtherParty ? 'Gelesen' : 'Ungelesen'}</span>
    </p>
);
